import { styled } from '@mui/material/styles';

export const EditorContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const EditorWrapper = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  position: 'relative',

  '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
    margin: 0,
  },

  '& h1': {
    fontWeight: 'bold',
    fontSize: '2em',
  },

  '& h2': {
    fontWeight: 'bold',
    fontSize: '1.5em',
  },

  '& h3': {
    fontWeight: 'bold',
    fontSize: '1.17em',
  },

  '& h4': {
    fontWeight: 'bold',
    fontSize: '15px',
  },

  '& .fr-wrapper': {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    border: 0,
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
  },
  '& .fr-view a': {
    color: '#0074A6',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    cursor: 'pointer',
  },
  '& .fr-view ul': {
    listStyleType: 'disc',
    marginLeft: theme.spacing(4),
  },
  '& .fr-view ol': {
    listStyleType: 'decimal',
    marginLeft: theme.spacing(4),
  },
  '& .fr-view ul ul': {
    paddingLeft: theme.spacing(4),
  },
  '& .fr-view ol ol': {
    paddingLeft: theme.spacing(4),
  },

  '& .fr-placeholder': {
    paddingTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    marginLeft: `${theme.spacing(3)} !important`,
  },

  '& .fr-toolbar': {
    border: 0,
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
    backgroundColor: theme.palette.background.paper,

    '&.fr-top': {
      borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
    },

    '& .fr-btn-grp': {
      margin: 0,

      '&:first-of-type': {
        marginLeft: theme.spacing(1.5),
      },

      '&.fr-float-right': {
        marginRight: theme.spacing(1.5),
      },
    },

    '& .fr-newline': {
      display: 'none',
    },
  },

  '& .fr-more-toolbar': {
    padding: '0 !important',
  },

  '& .fr-second-toolbar': {
    border: 0,
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
    backgroundColor: theme.palette.background.paper,
  },

  '& .fr-toolbar, & .fr-second-toolbar, & .fr-box.fr-basic .fr-wrapper': {
    borderColor: theme.palette.divider,
    border: 0,
  },

  '& .fr-box.fr-basic .fr-element': {
    paddingTop: 0,
    paddingBottom: 0,
    fontFamily: 'inherit',
    color: theme.palette.text.primary,
    minHeight: 100,
    padding: theme.spacing(2),
  },

  '& .fr-box.fr-basic.fr-focused': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}));

export const EditorSkeleton = styled('div')(({ theme }) => ({
  height: 100,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  fontSize: theme.typography.body2.fontSize,
}));

export const EditorActions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(1),
  justifyContent: 'flex-start',
}));
